import axios from "@/libs/axios";
import i18n from "@/libs/i18n";
import { ref } from "@vue/composition-api";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export default function useEazy() {
    const options = ref([]);

    options.value = [
        {
            value: "disconnected",
            text: i18n.t("settings.channels.eazy.channel.none-selected"),
        },
    ];

    const verifyKey = (apiKey, channelId) => {
        axios.post(`channels/${channelId}/authenticate`, { apiKey }).then((result) => {
            const allChannels = result.data.objects.map((object) => {
                const eazyJabberIdRegex = /(?<identity>.+)@(?<platform>.+)\.eazy\.im/;
                const regexResult = eazyJabberIdRegex.exec(object.jid);

                const platform = regexResult.groups.platform.toUpperCase();
                let identity = regexResult.groups.identity;

                if (platform === "whatsapp") {
                    identity = parsePhoneNumberFromString(identity, "NL").formatInternational();
                }

                return {
                    value: identity,
                    text: identity,
                    type: platform,
                };
            });

            options.value = [
                {
                    value: "disconnected",
                    text: i18n.t("settings.channels.eazy.channel.none-selected"),
                },
                ...allChannels.filter((channel) => channel.type === "WHATSAPP"),
            ];
        });
    };

    return {
        verifyKey,
        options,
    };
}
